import { Module } from 'vuex';
import { HotelStoreInterface, HotelSearchInterface } from '../../../../types/store/hotelStoreInterface';
import { HotelInterface } from '../../../../types/hotelInterface';
import HotelService from '../../../../services/management/hotel.service';

const getDefaultState = () => {
  return {
    list: [],
    listLoading: false,
    item: null,
    authData: null,
  };
};

const hotelStore: Module<HotelStoreInterface, any> = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state: any) {
      const s: any = getDefaultState();
      Object.keys(s).forEach(key => {
        state[key] = s[key];
      });
    },
    hotelsLoading(state, payload: boolean) {
      state.listLoading = payload;
    },
    hotelsLoaded(state, payload: HotelInterface[]) {
      state.list = payload;
    },
    hotelLoaded(state, payload: HotelInterface) {
      state.item = payload;
    },
    setAuthData(state, payload) {
      state.authData = payload;
    },
  },
  actions: {
    getHotels({ commit }): any {
      commit('hotelsLoading', true);
      return HotelService.getHotels()
        .then(res => {
          commit('hotelsLoading', false);
          commit('hotelsLoaded', res.data);
          return res.data;
        })
        .catch(() => {
          commit('hotelsLoading', false);
        });
    },
    getHotel({ commit }, id: number): any {
      return HotelService.getHotelInfo(id).then(res => {
        commit('hotelLoaded', res.data);
        return res.data;
      });
    },
    addHotel(context, data: any): any {
      return HotelService.addHotel(data);
    },
    updateHotel({ commit }, data: any): any {
      return HotelService.updateHotel(data['id'], data['form']).then(res => {
        commit('hotelLoaded', res.data);
        return res.data;
      });
    },
    getHotelRoomTypes(context, id: number): any {
      return HotelService.getHotelRoomTypes(id).then(res => {
        return res.data;
      });
    },
    getHotelCancellation(context, id: number): any {
      return HotelService.getCancellationPolicy(id);
    },
    updateHotelCancellation(context, data: any): any {
      return HotelService.updateCancellationPolicy(data);
    },
    getTLLincoln(context, hotel_id: number): any {
      return HotelService.getTLLincoln({ hotel_id });
    },
    checkTLLincoln(context, data: any): any {
      return HotelService.checkTLLincoln(data);
    },
    updateTLLincoln(context, data: any): any {
      return HotelService.updateTLLincoln(data);
    },
    checkHotelTLLincoln(context, data: any): any {
      return HotelService.checkHotelTLLincoln(data);
    },
    getBeds24(context, hotel_id: number): any {
      return HotelService.getBeds24({ hotel_id });
    },
    checkBeds24(context, data: any): any {
      return HotelService.checkBeds24(data);
    },
    updateBeds24(context, data: any): any {
      return HotelService.updateBeds24(data);
    },
    checkHotelBeds24(context, data: any): any {
      return HotelService.checkHotelBeds24(data);
    },
    getTemairazu(context, hotel_id: number): any {
      return HotelService.getTemairazu({ hotel_id });
    },
    getRakutsu(context, hotel_id: number): any {
      return HotelService.getRakutsu({ hotel_id });
    },
    getNeppan(context, hotel_id: number): any {
      return HotelService.getNeppan({ hotel_id });
    },
    getGMOInfo(context, hotel_id: number): any {
      return HotelService.getGMOInfo(hotel_id);
    },
    updateGMOInfo(context, data: any): any {
      return HotelService.updateGMOInfo(data);
    },
    getPriceSettings(context, data: any): any {
      return HotelService.getPriceSettings(data);
    },
    updatePriceSettings(context, data: any): any {
      return HotelService.updatePriceSettings(data);
    },
    getBookingRoomOptions(context, data: any): any {
      return HotelService.getBookingRoomOptions(data);
    },
    getBookingPlanOptions(context, data: any): any {
      return HotelService.getBookingPlanOptions(data);
    },
    updateRatePlanPriceSettings(context, data: any): any {
      return HotelService.updateRatePlanPriceSettings(data);
    },
  },
  getters: {
    searchHotels: state => (params: HotelSearchInterface) => {
      let result = state.list;
      if (params.prefecture !== 'all') {
        result = result.filter(hotel => hotel.prefecture_code === parseInt(params.prefecture, 10));
      }
      if (params.search) {
        const searchRegExp = new RegExp(params.search, 'i');
        result = result.filter(hotel => {
          return (
            (hotel.name.en && hotel.name.en.search(searchRegExp) !== -1) ||
            (hotel.name.ja && hotel.name.ja.search(searchRegExp) !== -1) ||
            (hotel.name.ko && hotel.name.ko.search(searchRegExp) !== -1) ||
            (hotel.name['zh-TW'] && hotel.name['zh-TW'].search(searchRegExp) !== -1) ||
            (hotel.name['zh-CN'] && hotel.name['zh-CN'].search(searchRegExp) !== -1) ||
            (hotel.address.en && hotel.address.en.search(searchRegExp) !== -1) ||
            (hotel.address.ja && hotel.address.ja.search(searchRegExp) !== -1) ||
            (hotel.address.ko && hotel.address.ko.search(searchRegExp) !== -1) ||
            (hotel.address['zh-TW'] && hotel.address['zh-TW'].search(searchRegExp) !== -1) ||
            (hotel.address['zh-CN'] && hotel.address['zh-CN'].search(searchRegExp) !== -1)
          );
        });
      }
      return result;
    },
  },
};

export default hotelStore;
